import { atom } from "recoil";

// API系の再取得トリガー用キー
export const apiRenderKeyState = atom<number>({
  key: "apiRenderKeyState",
  default: 0,
});
